import GaleryController from './GaleryController';

var galeryModule = angular.module('galery', [])
    .controller('GaleryController', GaleryController);

export default galeryModule;